import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "favorite-match-area bg-gondola3 position-relative z-1 bg-50" }
const _hoisted_2 = { class: "container mw-1356" }
const _hoisted_3 = { class: "row" }
const _hoisted_4 = ["data-aos-delay"]
const _hoisted_5 = { class: "hover-style2" }
const _hoisted_6 = { class: "border-style" }
const _hoisted_7 = ["src"]
const _hoisted_8 = ["src"]
const _hoisted_9 = ["src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_RouterLink = _resolveComponent("RouterLink")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.c.items, (item, index) => {
          return (_openBlock(), _createElementBlock("div", {
            key: index,
            class: "col-lg-6 col-md-6"
          }, [
            _createElementVNode("div", {
              class: _normalizeClass(["favorite-match-single-item position-relative z-1 overflow-hidden hover-style1", { 'mb-4 mb-md-0': index === 0 }]),
              "data-aos-delay": (index + 1) * 100,
              "data-aos": "fade-up",
              "data-aos-duration": "1000"
            }, [
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("h2", null, _toDisplayString(item.title), 1),
                _createVNode(_component_RouterLink, {
                  to: item.link,
                  class: "btn"
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("span", _hoisted_6, _toDisplayString(item.button_text), 1)
                  ]),
                  _: 2
                }, 1032, ["to"]),
                _createElementVNode("div", {
                  class: _normalizeClass(index === 0 ? 'favorite-match-img' : 'favorite-match-img-2')
                }, [
                  _createElementVNode("img", {
                    src: item.image_url || (index === 0 ? _ctx.img1 : _ctx.img2),
                    alt: "favorite-match"
                  }, null, 8, _hoisted_7)
                ], 2),
                _createElementVNode("img", {
                  src: item.shape_url || (index === 0 ? _ctx.shape1 : _ctx.shape2),
                  class: "favorite-shape",
                  alt: "favorite-shape"
                }, null, 8, _hoisted_8)
              ])
            ], 10, _hoisted_4)
          ]))
        }), 128))
      ])
    ]),
    _createElementVNode("img", {
      src: _ctx.c.bg_shape_url || _ctx.bgShape,
      class: "shape shape-8",
      alt: "shape"
    }, null, 8, _hoisted_9)
  ]))
}